module.exports = __webpack_public_path__ + "img/icon_error.10141aa2.svg";